'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _catalog = require('redux/actions/catalog');

var _theme = require('helpers/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CartProduct: {
        displayName: 'CartProduct'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/CartProduct/CartProduct.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var CartProduct = _wrapComponent('CartProduct')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var id = params.id;
        return dispatch((0, _extends3.default)({}, (0, _catalog.getProduct)(id), { show_404: location.pathname }));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        product_detail: state.catalog.product_detail
    };
}, { getProduct: _catalog.getProduct }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(CartProduct, _Component);

    function CartProduct() {
        (0, _classCallCheck3.default)(this, CartProduct);
        return (0, _possibleConstructorReturn3.default)(this, (CartProduct.__proto__ || (0, _getPrototypeOf2.default)(CartProduct)).apply(this, arguments));
    }

    (0, _createClass3.default)(CartProduct, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.product_detail.seo && this.props.product_detail.seo.semantic_url) {
                history.replaceState(null, null, '/product/' + this.props.product_detail.seo.semantic_url);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var product_detail = this.props.product_detail;


            var View = _theme.ThemeHelper.getViewForContainer('CartProduct');

            var title = product_detail && product_detail.seo && product_detail.seo.title || product_detail.name || '';
            var noindex = product_detail && product_detail.seo && product_detail.seo.indexation === false;

            var seo = product_detail.seo || {};

            var meta = [];

            if (seo.description) {
                meta.push({ name: 'description', content: seo.description });
            }
            if (seo.keywords) {
                meta.push({ name: 'keywords', content: seo.keywords });
            }
            if (noindex) {
                meta.push({ name: 'robots', content: 'noindex, nofollow' });
            }

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactHelmet2.default, { title: title }),
                meta.length > 0 ? _react3.default.createElement(_reactHelmet2.default, { meta: meta }) : null,
                _react3.default.createElement(View, { product_detail: product_detail })
            );
        }
    }]);
    return CartProduct;
}(_react2.Component), _class2.propTypes = {
    product_detail: _react2.PropTypes.object.isRequired,
    getProduct: _react2.PropTypes.func.isRequired
}, _temp)) || _class) || _class));

exports.default = CartProduct;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/CartProduct/CartProduct.jsx
// module id = 1803
// module chunks = 0